<template>
<div>
 <div class="loading" v-if="loading">
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
  <div id="main" :class="{enlarged}">
      <b-modal v-model="modalShow1" ok-only centered centered 
      :title="title" class="text-center text-info">
      
      {{msg}}
    </b-modal>
	<!-- top bar navigation -->
	<div class="headerbar">

		<!-- LOGO -->
        <div class="headerbar-left">
			
			 <ul class="list-inline menu-left mb-0">
                        <li class="float-left">
                            <button class="button-menu-mobile open-left">
								<i class="fa fa-fw fa-bars" @click="LSB()"></i>
                            </button>
                        </li>                        
                    </ul>
        </div>

        <nav class="navbar-custom">

                    <ul class="list-inline float-right mb-0">

						
						
                        <!-- <li class="list-inline-item dropdown notif">
                            <a class="nav-link dropdown-toggle arrow-none" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <i class="fa fa-fw fa-envelope-o"></i><span class="notif-bullet"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-arrow-success dropdown-lg">
                              
                                <div class="dropdown-item noti-title">
                                    <h5><small><span class="label label-danger pull-xs-right">12</span>Contact Messages</small></h5>
                                </div>

                                
                                <a href="#" class="dropdown-item notify-item">                                    
                                    <p class="notify-details ml-0">
                                        <b>Jokn Doe</b>
                                        <span>New message received</span>
                                        <small class="text-muted">2 minutes ago</small>
                                    </p>
                                </a>

                               
                                <a href="#" class="dropdown-item notify-item">                                    
                                    <p class="notify-details ml-0">
                                        <b>Michael Jackson</b>
                                        <span>New message received</span>
                                        <small class="text-muted">15 minutes ago</small>
                                    </p>
                                </a>

                               
                                <a href="#" class="dropdown-item notify-item">                                    
                                    <p class="notify-details ml-0">
                                        <b>Foxy Johnes</b>
                                        <span>New message received</span>
                                        <small class="text-muted">Yesterday, 13:30</small>
                                    </p>
                                </a>

                               
                                <a href="#" class="dropdown-item notify-item notify-all">
                                    View All
                                </a>

                            </div>
                        </li> -->
                        
						<li class="list-inline-item dropdown notif">
                            <a class="nav-link dropdown-toggle arrow-none" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <i class="fa fa-fw fa-bell-o"></i><span class="notif-bullet" v-if="notices.length > 0"></span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-lg" style="height: 250px; overflow-y: scroll; width: 250px;">
								<!-- item-->
                                <div class="dropdown-item noti-title">
                                    <h5><small><span class="label label-danger pull-xs-right">{{notices.length}}</span>Allerts</small></h5>
                                </div>
								
                                <!-- item-->
                                <a class="dropdown-item notify-item mb-1">
                                   
                                    <p class="notify-details" v-for=" notice in notices" :key="notice.title" @click="showMsg(notice.title, notice.msg)">
                                        <b style="cursor:pointer;">{{notice.title}}</b>
                                        <span class="mb-2" style="cursor:pointer;">{{notice.msg}}</span>
                                        <!-- <small class="text-muted">3 minutes ago</small> -->
                                        
                                    </p>
                                </a>

                               
                                <!-- All-->
                                <a v-if="notices.length > 0" class="dropdown-item notify-item notify-all" @click="delMsg()">
                                  <span style="cursor:pointer;"> Delete All Allerts </span>
                                </a>

                            </div>
                        </li>
                       
                        <li class="list-inline-item dropdown notif">
                            <a class="nav-link dropdown-toggle nav-user" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                                <!-- <img src="../../../static/images/admin.png" alt="Profile image" class="avatar-rounded"> -->
                                 <i class=" fa fa-user avatar-rounded"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right profile-dropdown">
                                <!-- item-->
                                <div class="dropdown-item noti-title">
                                    <h5 class="text-overflow"><small>Profile</small> </h5>
                                </div>

                                <!-- item-->
                                <!-- <a href="pro-profile.html" class="dropdown-item notify-item">
                                    <i class="fa fa-home"></i> <span>My Store</span>
                                </a> -->
                                <router-link :to="{name: 'storehome', params:{storename: storeid}}" class="dropdown-item notify-item"><i class="fa fa-building-o"></i> <span>My Store</span>
                                </router-link>
                                 <router-link to="/" class="dropdown-item notify-item"><i class="fa fa-home"></i> <span>Home</span>
                                </router-link>
                                <!-- item-->
                                <a v-on:click="logout" class="dropdown-item notify-item" style="cursor:pointer;">
                                    <i class="fa fa-power-off"></i> <span>Sign out</span>
                                </a>

                            </div>
                        </li>

                    </ul>

                    <ul class="list-inline menu-left mb-0">
                        <li class="float-left">
                            <button class="button-menu-mobile open-left">
								Admin
                            </button>
                        </li>                        
                    </ul>

        </nav>

	</div>
	<!-- End Navigation -->
	
    <div >
	<!-- Left Sidebar -->
	<div class="left main-sidebar" id="sidebar" v-if="showLSB">
	
		<div class="sidebar-inner leftscroll">

			<div id="sidebar-menu">
        
			<ul>

					<li class="submenu" @click="hideLSB()">
						<router-link :to="{name: 'dashboard'}"><i class="fa fa-fw fa-th"></i><span> Dashboard </span> </router-link>
                    </li>

					<li class="submenu" @click="hideLSB()">
						<router-link  :to="{name: 'adminhome'}"><i class="fa fa-home" aria-hidden="true"></i><span> Home Page </span> </router-link>
                    </li>

                    <!-- <li class="submenu" @click="hideLSB()">
						<router-link  :to="{name: 'adminabout'}"><i class="fa fa-user-plus" aria-hidden="true"></i><span> About Page </span> </router-link>
                    </li> -->

					<li class="submenu" @click="hideLSB()">
						<router-link  :to="{name: 'admincontact'}"><i class="fa fa-fw fa-phone"></i><span> Contact Page </span> </router-link>
                    </li>

         
                    <li class="submenu" @click="hideLSB()">
                    <router-link  :to="{name: 'admingallery'}"><i class="fa fa-file-image-o" aria-hidden="true"></i><span> Gallery </span> </router-link>
                            </li>
                

                     <li v-if="plan != 'Starter'" style="cursor:pointer;" @click="toggle()"><a class="cat"><i class="fa fa-fw fa-cubes"></i><span>Add Products </span><i class="fa fa-chevron-down" style="font-size:14px;"></i></a> </li>

                    <!-- <li class="" v-for="(hh, cat) in categoriesList" :key="cat">
                        <router-link class="subcat" :to="{name: 'addproduct'}"><i class="fa fa-fw fa-tag"></i><span>{{cat}}</span></router-link>
                    </li>   -->

                    <!-- <li v-if="plan != 'Starter'" class="submenu" @click="hideLSB()"><i class="fa fa-fw fa-cubes"></i><span>Add Products </span></li> -->


                     <li class="" v-if="toggleCat"  @click="hideLSB()" v-for="(values, key) in shopcats" :key="key">
                         
                        <router-link style="font-size:13px; padding-left:35px;" v-if="key != 'Mobiles' && key != 'Tablets' && key != 'Desktops' && key != 'Laptops' && shopcategory == ''" class="subcat" :to="{name: 'categories', params:{cat: key}}"><span style="color: #f3b55a;">{{key}}</span></router-link>
                         <router-link style="font-size:13px; padding-left:20px;" v-if="key == 'Mobiles' || key == 'Tablets' || key == 'Desktops' || key == 'Laptops'" class="subcat" :to="{name: 'mobiles', params:{cat: key}}"><span style="color: #f3b55a;">{{key}}</span></router-link>
                          <router-link style="font-size:13px; padding-left:20px;"  v-if="shopcategory == 'Vehicles'" class="subcat" :to="{name: 'vehicles', params:{cat: key}}"><span style="color: #f3b55a;" >{{key}}</span></router-link>
                       
                    </li>

                    <!-- <li class="submenu" @click="hideLSB()" v-if="plan == 'Starter'">
						<router-link  :to="{name: 'items'}"><i class="fa fa-cubes" aria-hidden="true"></i><span> Products </span> </router-link>
                    </li> -->
                    	<li class="submenu" @click="hideLSB()">
						<router-link  :to="{name: 'alloffers'}"><i class="fa fa-percent" aria-hidden="true"></i><span> Offers </span> </router-link>
                    </li>

                     <li class="submenu" @click="hideLSB()" v-if="plan == 'Premium' || plan ==  'Enterprise'">
						
                        <router-link  :to="{name: 'orders'}"><i class="fa fa-truck" aria-hidden="true"></i><span> Orders </span> </router-link>
                            
                    </li>

                     <li class="submenu" @click="hideLSB()">
						<router-link  :to="{name: 'customers'}"><i class="fa fa-users" aria-hidden="true"></i><span> Customers </span> </router-link>
                    </li>
					
					<!-- <li class="submenu" @click="show = false">
                        <a href="#"><i class="fa fa-fw fa-table"></i> <span> Products </span> <span class="menu-arrow"></span></a>
							<ul class="list-unstyled">
								<li><router-link :to="{name: 'allProducts'}">All Products</router-link></li>
								<li><router-link :to="{name: 'addproduct'}">Add New Items</router-link></li>
								
							</ul>
                    </li> -->
										
                   

                          
            	<li class="submenu" @click="hideLSB()">
                        <router-link :to="{name: 'storehome', params:{storename: storeid}}"><i class="fa fa-fw fa-building-o"></i><span>View Store</span></router-link>
                           
                    </li>
				
                   

					
                   
					<li class="submenu" @click="hideLSB()">
                        <router-link :to="{name:'myshopin'}"><i class="fa fa-fw fa-shopping-cart"></i><span>MY SHOPiN</span></router-link>
                           
                    </li>
          <!-- <li class="submenu" @click="hideLSB()">
                        <router-link :to="{name:'adminsetting'}"><i class="fa fa-fw fa-cog"></i><span>Setting</span></router-link>
                           
                    </li>

					<li class="submenu" @click="hideLSB()" v-if="plan != 'Starter'">
                        <router-link class="pro" :to="{name:'payment'}"><i class="fa fa-fw fa-money"></i><span>Payment</span></router-link>
                           
                    </li> -->
                    
					
            </ul>

            <div class="clearfix"></div>

			</div>
        
			<div class="clearfix"></div>

		</div>
    
	</div>
    
    </div>
	<!-- End Sidebar -->


   


 <div class="content-page">
	
		<!-- Start content -->
        <div class="content" v-if="show2">
            
			<div class="container-fluid">
                <Dashboard v-if="show"/>
                <router-view :key="$route.fullPath"></router-view>
                 
                <!-- <AllProducts/>
                <AddProduct/> -->
             </div>
			<!-- END container-fluid -->

		</div>
		<!-- END content -->
   
    </div>
    
	<!-- END content-page -->
    <footer class="">
		<AdminFooter/>
	</footer>

</div>
<!-- END main -->
</div>
</div>
</template>

<script>
import AdminFooter from './AdminFooter'
import firebase from 'firebase/app';
import db from "../../config/FirebaseInit"
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'
import Dashboard from './Dashboard'

// import "../../assets/admin/js/detect.js";
import "../../assets/admin/js/fastclick.js";
// import "../../assets/admin/js/pikeadmin.js";
export default {
  name: "admin",
  components: {
      Dashboard,
      AdminFooter
  },
  data() {
      return{
          show: true,
          show2:false,
          toggleCat:false,
         isLoggedIn: false,
        currentUser: false,
         categoriesList: [],
            subcategories: [],
            category: '',
            subcategory: '',
            shops: [],
            notices: [],
            storeid:'',
            shopcats:{},
            title:'',
            msg:"",
            modalShow1:false,
            showLSB: true,
            enlarged:'',
            plan:'',
            shopcategory:'',
            loading:false,
            fetch:true,
        
      };
      
  },

   watch: {
       $route () {
           if(this.$route.fullPath == '/admin/' || this.$route.fullPath == '/admin'){
          this.show = true
      }
       },
       show () {
           //console.log('show is', this.show)
       },
    //   category () {
    //     this.subcategories = []
    //     this.subcategory = ""
    //     if (this.category.length > 0) {
    //             this.subcategories = this.categoriesList[this.category]
    //         }

    //   },
    //   shops () {
    //      if(this.shops[0].shoptype == 'Fashion'){
    //       this.categoriesList = ClothingAccessories
    //       //console.log(this.categoriesList)
    //   }
    //   if(this.shops[0].shoptype == 'Elec'){
    //       this.categoriesList = mobiles
    //   }
    //   }
    },

  methods: {
      toggle(){
          if(this.toggleCat){
              this.toggleCat = false
          }else if(!this.toggleCat){
              this.toggleCat = true
          }
      },
      hideLSB(){
           //console.log("screen.width",screen.width)
          this.show = false
            if(screen.width < 1290){
                //console.log('this.showLSB',this.showLSB)
                this.showLSB = false
                this.enlarged = 'right-bar-enabled'
                //console.log('this.showLSB',this.showLSB)
            }
      },
      LSB(){
          //console.log('this.showLSB',this.showLSB) 
          if(this.showLSB){
          this.showLSB = false
          this.enlarged = 'right-bar-enabled'
          //console.log('this.showLSB',this.showLSB)
          }else{
              this.showLSB = true
              this.enlarged = ''
              //console.log('this.showLSB',this.showLSB)
          }
      },
      showMsg(tit, msg){
          this.title = tit
          this.msg = msg
          this.modalShow1 = true
      },
      delMsg(){
           db.collection("shops").doc(this.shops[0].id)
		     .collection('notify').get()
			.then(querySnapshot => {
					querySnapshot.forEach(doc => {
					//console.log('doc id',doc.id)
					 db.collection("shops").doc(this.shops[0].id)
		            .collection('notify').doc(doc.id).delete().then(() => {
              				//console.log('msg deleted')
					})
					 .catch(error => alert(error));
                })
             })
             .then( () => {
                 this.notices = []
             })

      },

      logout () {
          firebase.auth().signOut()
          .then( () => {
              this.$router.push('/')
          })
      },
      
  },
  mounted() {
       if(this.$route.fullPath == '/admin/' || this.$route.fullPath == '/admin'){
          this.show = true
      }
  },
  created() {
      //console.log('route is', this.$route)
     this.loading = true
     this.fetch = false
      if(this.$route.fullPath != '/admin/' || this.$route.fullPath != '/admin'){
          this.show = false
      }
      
      if(firebase.auth().currentUser) {
          this.isLoggedIn = true;
          this.currentUser = firebase.auth().currentUser.email;
          this.storeid = firebase.auth().currentUser.uid
          //console.log(firebase.auth().currentUser.uid)
        
        try{
            firebase.app(firebase.auth().currentUser.uid)
            this.$store.state.secondaryDatabase = firebase.app(firebase.auth().currentUser.uid).firestore()
            this.show2 = true
            //console.log('secondaryDB Exsits', this.$store.state.secondaryDatabase)
        }catch(err){
        db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
          .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
                'id': doc.id,
              'shoptype' : doc.data().shoptype,
              'categories' : doc.data().categories,
              'name' : doc.data().name,
              'plan':doc.data().plan,
              'shopcat':doc.data().cat,
              'config': doc.data().config
              
            }
            this.shops.push(data)
          })
        })
        .then( () => {
          //console.log('this.shops[0].config', this.shops[0].config)
          if (!doc.data().noDB) { // having own db
            if(this.shops[0].config){
              //console.log('config', this.shops[0].config)
              var secondaryAppConfig = this.shops[0].config
                  var secondary = firebase.initializeApp(secondaryAppConfig, firebase.auth().currentUser.uid)
              this.$store.state.secondaryDatabase = secondary.firestore()
              // this.$store.state.secondaryApp = this.$route.params.storename
              this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
              this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
                  //console.log("Woohoo! Multi-Tab Persistence!");
              });
              this.show2 = true
              //console.log('secondaryDB', this.$store.state.secondaryDatabase)
            }
          }else{
            //console.log('shop config', this.shops[0].config)
            this.$store.state.secondaryDatabase = db;
            this.show2 = true
          }
            
        })
           
        }

        db.collection('shops').where('owner', '==', firebase.auth().currentUser.uid).get()
          .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
                'id': doc.id,
              'shoptype' : doc.data().shoptype,
              'categories' : doc.data().categories,
              'name' : doc.data().name,
              'plan':doc.data().plan,
              'shopcat':doc.data().cat,
              'config': doc.data().config
              
            }
            this.shops.push(data)
            this.plan = this.shops[0].plan
            if(this.shops[0].shopcat == 'Vehicles'){
                this.shopcategory = this.shops[0].shopcat
            }
            
            this.shopcats = this.shops[0].categories
              //console.log(this.shops[0].id)
              //console.log(this.shops[0].categories)
          })
          this.loading = false
              this.fetch = true
        })
        .then( () => {
              //console.log('this.notices')
          db.collection('shops').doc(this.shops[0].id)
              .collection('notify').get()
            .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              const notice = { 
                  'title': doc.data().notice.title,
                  'msg' : doc.data().notice.msg} 
                this.notices.push(notice)
                //console.log(this.notices)
              
            })
              
            })
          })
      }

     
  
    this.$nextTick(() => {
      var resizefunc = [];

    //   $(document).ready(function() {
    //     $(function() {
    //       $(".nicescroll").niceScroll({ cursorcolor: "#858586" });
    //     });
    //   });

      !(function($) {
        "use strict";

        var Sidemenu = function() {
          (this.$body = $("body")),
            (this.$openLeftBtn = $(".open-left")),
            (this.$menuItem = $("#sidebar-menu a"));
        };
        (Sidemenu.prototype.openLeftBar = function() {
          $("#main").toggleClass("enlarged");
          $("#main").addClass("forced");

          if (
            $("#main").hasClass("enlarged") &&
            $("body").hasClass("adminbody")
          ) {
            $("body")
              .removeClass("adminbody")
              .addClass("adminbody-void");
          } else if (
            !$("#main").hasClass("enlarged") &&
            $("body").hasClass("adminbody-void")
          ) {
            $("body")
              .removeClass("adminbody-void")
              .addClass("adminbody");
          }

          if ($("#main").hasClass("enlarged")) {
            $(".left ul").removeAttr("style");
          } else {
            $(".subdrop")
              .siblings("ul:first")
              .show();
          }
        }),
          //menu item click
          (Sidemenu.prototype.menuItemClick = function(e) {
            if (!$("#main").hasClass("enlarged")) {
              if (
                $(this)
                  .parent()
                  .hasClass("submenu")
              ) {
              }
              if (!$(this).hasClass("subdrop")) {
                // hide any open menus and remove all other classes
                $("ul", $(this).parents("ul:first")).slideUp(350);
                $("a", $(this).parents("ul:first")).removeClass("subdrop");
                $("#sidebar-menu .pull-right i")
                  .removeClass("md-remove")
                  .addClass("md-add");

                // open our new menu and add the open class
                $(this)
                  .next("ul")
                  .slideDown(350);
                $(this).addClass("subdrop");
                $(".pull-right i", $(this).parents(".submenu:last"))
                  .removeClass("md-add")
                  .addClass("md-remove");
                $(".pull-right i", $(this).siblings("ul"))
                  .removeClass("md-remove")
                  .addClass("md-add");
              } else if ($(this).hasClass("subdrop")) {
                $(this).removeClass("subdrop");
                $(this)
                  .next("ul")
                  .slideUp(350);
                $(".pull-right i", $(this).parent())
                  .removeClass("md-remove")
                  .addClass("md-add");
              }
            }
          }),
          //init sidemenu
          (Sidemenu.prototype.init = function() {
            var $this = this;

            // var ua = navigator.userAgent,
            //   event = ua.match(/iP/i) ? "touchstart" : "click";

            //bind on click
            // this.$openLeftBtn.on(event, function(e) {
            //   e.stopPropagation();
            //   $this.openLeftBar();
            // });

            // LEFT SIDE MAIN NAVIGATION
            // $this.$menuItem.on(event, $this.menuItemClick);

            // NAVIGATION HIGHLIGHT & OPEN PARENT
            $("#sidebar-menu ul li.submenu a.active")
              .parents("li:last")
              .children("a:first")
              .addClass("active")
              .trigger("click");
          }),
         // init Sidemenu
          ($.Sidemenu = new Sidemenu()),
          ($.Sidemenu.Constructor = Sidemenu);
      })(window.jQuery),
        //main app module
        (function($) {
          "use strict";

          var App = function() {
            (this.pageScrollElement = "html, body"), (this.$body = $("body"));
          };

          //on doc load
          (App.prototype.onDocReady = function(e) {
            FastClick.attach(document.body);
            resizefunc.push("changeptype");

            $(".animate-number").each(function() {
              $(this).animateNumbers(
                $(this).attr("data-value"),
                true,
                parseInt($(this).attr("data-duration"))
              );
            });

            //RUN RESIZE ITEMS
            // $(window).resize(debounce(resizeitems, 100));
            // $("body").trigger("resize");

            // right side-bar toggle
            $(".right-bar-toggle").on("click", function(e) {
              $("#main").toggleClass("right-bar-enabled");
            });
          }),
            //initilizing
            (App.prototype.init = function() {
              var $this = this;
              $(document).ready($this.onDocReady);
              $.Sidemenu.init();
            }),
            ($.App = new App()),
            ($.App.Constructor = App);
        })(window.jQuery),
        //initializing main application module
        (function($) {
          "use strict";
          $.App.init();
        })(window.jQuery);

      function executeFunctionByName(functionName, context) {
        var args = [].slice.call(arguments).splice(2);
        var namespaces = functionName.split(".");
        var func = namespaces.pop();
        for (var i = 0; i < namespaces.length; i++) {
          context = context[namespaces[i]];
        }
        return context[func].apply(this, args);
      }
      var w, h, dw, dh;
      var changeptype = function() {
        w = $(window).width();
        h = $(window).height();
        dw = $(document).width();
        dh = $(document).height();

        if (jQuery.browser.mobile === true) {
          $("body")
            .addClass("mobile")
            .removeClass("adminbody");
        }

        if (!$("#main").hasClass("forced")) {
          if (w > 990) {
            $("body")
              .removeClass("smallscreen")
              .addClass("widescreen");
            $("#main").removeClass("enlarged");
          } else {
            $("body")
              .removeClass("widescreen")
              .addClass("smallscreen");
            $("#main").addClass("enlarged");
            $(".left ul").removeAttr("style");
          }
          if (
            $("#main").hasClass("enlarged") &&
            $("body").hasClass("adminbody")
          ) {
            $("body")
              .removeClass("adminbody")
              .addClass("adminbody-void");
          } else if (
            !$("#main").hasClass("enlarged") &&
            $("body").hasClass("adminbody-void")
          ) {
            $("body")
              .removeClass("adminbody-void")
              .addClass("adminbody");
          }
        }
      };

      var debounce = function(func, wait, immediate) {
        var timeout, result;
        return function() {
          var context = this,
            args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) result = func.apply(context, args);
          return result;
        };
      };

    //   function resizeitems() {
    //     if ($.isArray(resizefunc)) {
    //       for (i = 0; i < resizefunc.length; i++) {
    //         window[resizefunc[i]]();
    //       }
    //     }
    //   }
    });
  }
};
</script>

<style scoped>
@import url('~@/assets/main/css/loading.css');
@import url("~@/assets/admin/css/style.css");
/* @import url("~@/assets/admin/font-awesome/css/font-awesome.min.css"); */
.submenu:active{
    color: #ffffff !important;
  background-color: #6194c1;
    /* padding: 6px 0px !important;
     padding-left: 12px !important; */
     /* font-size: 0.80rem !important; */
}
.cat{
    padding-left: 12px !important;
    color: #fff !important;
}
.cat:hover{
    color: #fff !important;
    border-left: 2px solid transparent !important;
    background-color: transparent !important;
}
.cat:active{
   color: #fff !important;
    background-color: transparent !important;
}
#sidebar::-webkit-scrollbar-track{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	border-radius: 10px;
	background-color: #F5F5F5;
}

#sidebar::-webkit-scrollbar{
	width: 10px;
	background-color: #F5F5F5;
}

#sidebar::-webkit-scrollbar-thumb{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue